export const animations = {
  idleLoop: new URL('./idle_loop.vrma', import.meta.url),
  fCommon: {
    greeting: new URL('./f-common/greeting.vrma', import.meta.url),
    peaceSign: new URL('./f-common/peace_sign.vrma', import.meta.url),
    shoot: new URL('./f-common/shoot.vrma', import.meta.url),
    showFullBody: new URL('./f-common/show_full_body.vrma', import.meta.url),
    squat: new URL('./f-common/squat.vrma', import.meta.url),
  },
}

// Ordered list of f-common animation URLs for playlist cycling on the web stage.
export const fCommonAnimationUrls: string[] = Object.values(animations.fCommon).map(url => url.href)
